import DbConfig from '../../../config/DbConfig.js'
import {getFansWithCustomById} from './friend.js'
import {formatTimeToYMDHms,socketType2DbType,trim} from '../../functions/Common.js'

// 保存转移的相关数据，包括客服信息，粉丝信息，最近聊天记录信息
export function saveTransferData(data,callback){
	let db = DbConfig.connect()
	let promise = Promise.resolve()
	// 保存最近聊天记录
	let recently = data.recently
	if(recently !== undefined && recently.length>0){
		for (let i = 0; i < recently.length; i++) {
			promise = promise.then(()=>{
				return new Promise((resolve,reject)=>{
					db.transaction(tx=>{
						for(let i in recently){
							let no_read_num = 0
							if(recently[i].is_new === 1){
								no_read_num = 1
							}
							// 添加数据
							tx.executeSql('insert into yswl_recently(id,account_open_id,friends_open_id,friend_or_cluster_id,friend_img,friend_name,chat_type,last_chat_msg,last_chat_msg_type,last_modified_time,is_new,is_top,is_collect,no_disturb,no_read_num,is_transfer,is_me)'+
								'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
								[recently[i].id,recently[i].account_open_id,recently[i].friends_open_id,recently[i].friend_or_cluster_id,recently[i].friend_img,recently[i].friend_name,recently[i].chat_type,recently[i].last_chat_msg,recently[i].last_chat_msg_type,recently[i].last_modified_time,recently[i].is_new,recently[i].is_top,recently[i].is_collect,recently[i].no_disturb,no_read_num,1,recently[i].is_me],
								(tx,results)=>{
									// console.log(results)
								},
								(tx,error)=>{
									// console.log(error)
								})
						}
						resolve()
					})
				})
			})
		}
	} 
	// 保存粉丝信息
	let fans = data.friends
	if(fans !== undefined && fans.length>0){
		for (let i = 0; i < fans.length; i++) {
			promise = promise.then(()=>{
				return new Promise((resolve,reject)=>{
					db.transaction(tx=>{
						for(let i in fans){
							// 添加数据
							tx.executeSql('insert into yswl_custom_friends(id,custom_id,open_id,wx_name,wx_photo,friend_type,alias,con_remark,sex,sign,fans_type,country,province,city,is_comment,is_zan,mobile,create_time,is_transfer)'+
								'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
								[fans[i].id,fans[i].custom_id,fans[i].open_id,fans[i].wx_name,fans[i].wx_photo,fans[i].friend_type,fans[i].alias,fans[i].con_remark,fans[i].sex,fans[i].sign,fans[i].fans_type,fans[i].country,fans[i].province,fans[i].city,fans[i].is_comment,fans[i].is_zan,fans[i].mobile,fans[i].create_time,1],
								(tx,results)=>{
									// console.log(results)
								},
								(tx,error)=>{
									// console.log(error)
								})
						}
						resolve()
					})
				})
			})
		}
	}
	// 保存客服信息
	let custom = data.custom
	if(custom !== undefined && custom.length>0){
		for (let i = 0; i < custom.length; i++) {
			promise = promise.then(()=>{
				return new Promise((resolve,reject)=>{
					db.transaction(tx=>{
						for(let i in custom){
							tx.executeSql('insert into yswl_custom(id,open_id,manager_id,wx_name,wx_photo,phone_id,identity,snsId,async_fans_id,async_recent_id,async_chat_id,async_cluster_id,async_cluster_chat_id,async_fans_tag_id,is_transfer)'+
								'values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
								[custom[i].id,custom[i].open_id,custom[i].manage_id,custom[i].wx_name,custom[i].wx_photo,custom[i].phone_id,custom[i].identity,custom[i].snsId,0,0,0,0,0,0,1],
								(tx,results)=>{
									// console.log(results)
								},
								(tx,error)=>{
									// console.log(error)
								})
						}
						resolve()
					})
				})
			})
		}
	} 
	
	promise = promise.then(()=>{
		callback()
	})
}

// 删除转移的相关数据，包括粉丝信息，最近聊天记录信息
export function delTransferData(fansId,callback){
	let db = DbConfig.connect()
	let promise = Promise.resolve()
	promise = promise.then(()=>{
		return new Promise((resolve,reject)=>{
			db.transaction(tx=>{
				// 删除聊天记录
				tx.executeSql('delete from yswl_recently where friend_or_cluster_id = ? and chat_type = 1',
					[fansId],
					(tx,results)=>{
						// console.log(results)
					},
					(tx,error)=>{
						// console.log(error)
					})
				resolve()
			})
		})
	})
	promise = promise.then(()=>{
		return new Promise((resolve,reject)=>{
			db.transaction(tx=>{
				// 删除聊天记录
				tx.executeSql('delete from yswl_custom_friends where id = ?',
					[fansId],
					(tx,results)=>{
						// console.log(results)
					},
					(tx,error)=>{
						// console.log(error)
					})
				resolve()
			})
		})
	})
	promise = promise.then(()=>{
		callback(true)
	})
}